import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from 'antd';
export const CompanyLogo = ({ data })=>/*#__PURE__*/ _jsx(Image, {
        width: 64,
        height: 64,
        src: data.companyLogoUrl,
        preview: false,
        title: data.companyName,
        alt: data.companyName
    });
